<template>
  <view class="loading">
    <view class="loading-icon">
      <view class="inner" />
    </view>
    <view>加载中…</view>
  </view>
</template>

<script>
    import { createComponent } from '@didi/es-mpx-creator'

    createComponent({
      name: 'loading'
    })
</script>

<style lang="stylus" scoped>
  .loading
    display flex
    justify-content center
    align-items center
    width 100%
    height 120rpx
    font-family PingFangSC-Regular
    font-size 20rpx
    color #666666
    font-weight 400
  .loading-icon
    display flex
    align-items center
    justify-content center
    width 26rpx
    height 26rpx
    margin-right 16rpx
    border-radius 50%
    background conic-gradient(#CCCCCC 0, #CCCCCC 75%, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0) 100%)
    box-sizing border-box
    animation rotate 800ms linear infinite
    @keyframes rotate
      0%
        transform rotate(0)
      50%
        transform rotate(180deg)
      100%
        transform rotate(360deg)
    .inner
      width 20rpx
      height 20rpx
      border-radius 50%
      background-color #f6f8fb
</style>

<script type="application/json">
    {
      "component": true,
      "usingComponents": {}
    }
</script>
